/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import CircleWithBorder from '../CircleWithBorder';

export interface SvgIconProps {
  color: string;
  size: string;
}

export const IconSquare = () => (
  <div style={{ width: 16, height: 16, border: '1px solid #fff', borderRadius: 4, display: 'inline-block' }}/>
);

export const IconBack = () => (
  <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 0L8.25 6.875L16.5 0" transform="translate(8.375 0.75) rotate(90)" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const IconForward = () => (
  <div style={{ marginRight: 8 }}>
    <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0L8.25 6.875L16.5 0" transform="translate(1.625 17.25) rotate(-90)" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  </div>
);

export const IconAccess = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
    <g id="icon-access">
      <path
        stroke="white"
        fill="none"
        d="M5.67,15.43V14.16a.8.8,0,0,1,.8-.8H7.74a.79.79,0,0,0,.8-.79V10.25L9.71,9.08a6.18,6.18,0,1,1,5.23,5.22L8.39,20.85a3.77,3.77,0,0,1-5,.33,3.69,3.69,0,0,1-.7-4.95H4.88A.79.79,0,0,0,5.67,15.43Z"
      />
      <circle
        stroke="white"
        fill="none"
        cx="16.29"
        cy="7.16"
        r="1.85"
      />
    </g>
  </svg>
);

export const IconPlay = ({ fillClassName, borderClassName }) => (
  <div
    style={{
      width: 36,
      height: 36,
      border: '1px solid black',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
    className={borderClassName}
  >
    <svg width="26" height="26" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
      <path
        d="M25.1666 15.1341C25.8333 15.519 25.8333 16.4813 25.1666 16.8662L12.1666 24.3717C11.5 24.7566 10.6666 24.2755 10.6666 23.5057L10.6666 8.49461C10.6666 7.72481 11.5 7.24368 12.1666 7.62858L25.1666 15.1341Z"
        className={fillClassName}
      />
    </svg>
  </div>
);

export const IconClock = ({ strokeClassName }) => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
    <path d="M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z" className={strokeClassName} strokeWidth="1.5" strokeMiterlimit="10"/>
    <path d="M10.7 5.3999V11.6999L16.2 14.8999" className={strokeClassName} strokeWidth="1.5" strokeMiterlimit="10"/>
  </svg>
);

export const IconSurvey = ({ strokeClassName }) => (
  <svg width="28" height="32" viewBox="0 0 28 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.05 3.40039H23.45C25.35 3.40039 26.85 4.90039 26.85 6.80039V27.6004C26.85 29.5004 25.35 31.0004 23.45 31.0004H4.65C2.75 31.0004 1.25 29.5004 1.25 27.6004V6.80039C1.25 4.90039 2.75 3.40039 4.65 3.40039H7.15"
      className={strokeClassName}
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M16.35 1H11.85C9.05 1 6.75 3.3 6.75 6.1V6.7H21.35V6.1C21.35 3.3 19.15 1 16.35 1Z"
      className={strokeClassName}
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M14.05 23.0001C13.85 23.0001 13.65 22.9001 13.45 22.8001C13.15 22.6001 12.95 22.4001 12.75 22.3001C11.55 21.4001 10.45 20.5001 9.54998 19.3001C8.74998 18.4001 8.44998 17.4001 8.74998 16.2001C9.14998 14.5001 10.75 13.5001 12.35 14.0001C13.05 14.2001 13.65 14.6001 14.05 15.3001C14.45 14.6001 15.05 14.2001 15.75 14.0001C17.35 13.6001 18.95 14.6001 19.35 16.2001C19.65 17.4001 19.35 18.4001 18.55 19.3001C17.55 20.4001 16.45 21.4001 15.35 22.3001C15.15 22.5001 14.85 22.7001 14.65 22.8001C14.45 22.9001 14.25 23.0001 14.05 23.0001Z"
      className={strokeClassName}
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
  </svg>
);

export const IconPause = ({ fillClassName, borderClassName }) => (
  <div
    style={{
      width: 24,
      height: 24,
      border: '1px solid',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      paddingLeft: 1,
    }}
    className={borderClassName}
  >
    <svg width="7" height="10" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
      <path d="M0 0H3.75V14H0V0Z" className={fillClassName}/>
      <path d="M6.25 0H10V14H6.25V0Z" className={fillClassName}/>
    </svg>
  </div>
);
